interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const ArrowFluxoPage = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg width="30" height="19" fill={color} xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9.017 17.856a.719.719 0 0 0 1.016-.018.719.719 0 0 0 .018-1.016L2.958 9.729l25.79.09a.751.751 0 0 0 .747-.716.688.688 0 0 0-.69-.721L3.03 8.292l6.776-6.777A.719.719 0 0 0 9.824.5a.719.719 0 0 0-1.017.018L.76 8.565A.719.719 0 0 0 .742 9.58l8.275 8.275Z" className={className} /></svg>
    </>
  );
}

export default ArrowFluxoPage;